const mutations = {
  confirmCancelDashboard(state, confirmCancelDashboard) {
    state.confirmCancelDashboard = confirmCancelDashboard
  },
  deleteIndexDashboard(state, deleteIndexDashboard) {
    state.deleteIndexDashboard = deleteIndexDashboard
  },
  deleteLabelDashboard(state, deleteLabelDashboard) {
    state.deleteLabelDashboard = deleteLabelDashboard
  },
  denyDeleteDashboard(state, denyDeleteDashboard) {
    state.denyDeleteDashboard = denyDeleteDashboard
  },
  formDashboard(state, formDashboard) {
    state.formDashboard = formDashboard
  },
  isModalVisibleDashboard(state, isModalVisibleDashboard) {
    state.isModalVisibleDashboard = isModalVisibleDashboard
  },
  isValidDashboardForm(state, isValidDashboardForm) {
    state.isValidDashboardForm = isValidDashboardForm
  },
  promptDeleteDashboard(state, promptDeleteDashboard) {
    state.promptDeleteDashboard = promptDeleteDashboard
  },
}

export default mutations
